import React from "react";

export default function Footer() {
  return (
    <div style={{ marginTop: "90px", fontSize: "0.7rem" }}>
      <a
        style={{ color: "#000" }}
        className="github-link"
        target="_blank"
        rel="noreferrer"
        href="https://github.com/Kat-Str/weather-react"
      >
        Open-source code
      </a>
      <span> by Katarzyna Strzałek</span>
    </div>
  );
}
